import React from 'react';

function Footer({ onPrivacyClick, onTermsClick, onContactClick }) {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-brand">
          <span>📚 StoryMeal</span>
          <span className="footer-powered">powered by <a href="https://austrasoft.com" target="_blank" rel="noopener noreferrer">Austrasoft.com</a></span>
        </div>
        <div className="footer-links">
          <button onClick={onPrivacyClick} className="footer-link">Privacy Policy</button>
          <span className="footer-separator">|</span>
          <button onClick={onTermsClick} className="footer-link">Terms of Service</button>
          <span className="footer-separator">|</span>
          <button onClick={onContactClick} className="footer-link">Contact Us</button>
        </div>
        <div className="footer-copyright">
          <p>&copy; {new Date().getFullYear()} StoryMeal. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;